import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  selectScope,
  selectCategory,
  fetchMoviesIfNeeded,
  selectYear,
  fetchNewsIfNeeded,
  fetchMoviesFromFestivalIfNeeded,
  selectSection,
  fetchMovies,
  selectMov2Filter,
  fetchCitiesIfNeeded,
  fetchMenusIfNeeded,
  fetchSectionsIfNeeded,
  fetchPosterIfNeeded,
  fetchSponsorHomeIfNeeded,
  CLIENT_BASE_URL
} from "../../actions";
//  import { Link } from 'react-router-dom'
import { Carousel, CarouselItem } from "react-bootstrap";
import { Link } from "react-router-dom";
import CarouselImage from "./CarouselImage.jpg";
import { HeaderView } from "../HeaderView/HeaderView";
import { FooterLinks } from "../FooterLinks/FooterLinks";
//  import {ProgramView} from '../ProgramView/ProgramView'
import { MoviesView } from "../MoviesView/MoviesView";
import { SocialView } from "../SocialView/SocialView";
import { NewsView } from "../NewsView/NewsView";
import { SponsorView } from "../SponsorView/SponsorView";
import { SearchView } from "../SearchView/SearchView";

//  import classes from './MovieMakerView.scss'

// We define mapStateToProps where we'd normally use
// the @connect decorator so the data requirements are clear upfront, but then
// export the decorated component after the main class definition so
// the component can be tested w/ and w/o being connected.
// See: http://rackt.github.io/redux/docs/recipes/WritingTests.html
const featuredImages = [CarouselImage];

export class MovieMakerView extends React.Component {
  constructor(props) {
    super(props);

    // console.log('MovieMakerView!!!!!!!!!')
    this.gotoPage = this.gotoPage.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.getALLmovies = this.getALLmovies.bind(this);
    this.drawBackgroundImage = this.drawBackgroundImage.bind(this);
    this.renderBannerContainer = this.renderBannerContainer.bind(this);
    this.renderBannerLink = this.renderBannerLink.bind(this);
    this.onClickTagLabel = this.onClickTagLabel.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(selectScope("distrib"));
    dispatch(fetchMenusIfNeeded("distrib"));
    dispatch(fetchPosterIfNeeded(this.props.selectedScope));
  }

  componentDidMount() {
    console.log("MOVIEMAKER componentDidMount!");
    this.props.dispatch(selectCategory("0"));
    this.props.dispatch(selectYear("2018"));
    // this.props.dispatch(selectCity('1'))
    const { dispatch, selectedCategory } = this.props;

    // console.log('this.props.selectedScope !!!!!', this.props.selectedScope)

    // dispatch(fetchPosterIfNeeded(this.props.selectedScope))

    dispatch(fetchMoviesIfNeeded(selectedCategory, "distrib"));
    dispatch(fetchNewsIfNeeded("distrib"));
    dispatch(fetchCitiesIfNeeded());
    // dispatch(fetchMoviesFromFestivalIfNeeded('1'))
    dispatch(fetchSectionsIfNeeded("movies"));
    dispatch(fetchSponsorHomeIfNeeded());

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  }

  componentWillReceiveProps(nextProps) {
    const {
      dispatch,
      selectedCategory,
      selectedCity,
      selectedScope
    } = nextProps;

    if (selectedScope !== this.props.selectedScope) {
      dispatch(selectMov2Filter("0", "FILMES"));
      dispatch(selectSection("SECÇÕES"));
      dispatch(fetchMovies(selectedCategory, "distrib"));
      dispatch(fetchMenusIfNeeded(selectedScope));
      dispatch(fetchNewsIfNeeded("distrib"));
      dispatch(fetchPosterIfNeeded(selectedScope));
      // dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope))
    }

    if (nextProps.selectedCategory !== this.props.selectedCategory) {
      // dispatch(fetchMoviesIfNeeded(selectedCategory, selectedScope))
      // dispatch(fetchNewsIfNeeded('distrib'))
      dispatch(fetchCitiesIfNeeded());
    }

    if (nextProps.selectedCity !== selectedCity) {
      dispatch(fetchMoviesFromFestivalIfNeeded(selectedCity));
    }

    this.handleResize();
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  getFeaturedImage(pos) {
    return {
      backgroundImage: `url('${featuredImages[pos]}')`
    };
  }

  drawBackgroundImage(poster) {
    poster = CLIENT_BASE_URL + poster;
    return {
      backgroundImage: `url('${poster}')`
    };
  }

  renderCarrousel() {

    const { posters } = this.props;

    if (
        typeof posters === "undefined" ||
        !posters.hasOwnProperty("poster") ||
        typeof posters["poster"] === "undefined" ||
        !posters["poster"].length
    ) {

      return [];

    } else {

      return posters["poster"].map((info, i) => {
        return (
            <CarouselItem key={i}>
              {this.renderBannerLink(i, info)}
              <div key={`z${i}`} className="carousel-caption">
                <p dangerouslySetInnerHTML={{ __html: info.description }} />
              </div>
            </CarouselItem>
        );
      });
    }
  }

  renderBannerLink(i, info) {
    if (info.link === "") {
      return (
        <Link to="/">
          <div
            key={`k${i}`}
            className="carousel-img"
            style={this.drawBackgroundImage(info.img)}
          />
        </Link>
      );
    }

    let lnk = info.link;

    if (info.link.indexOf("festadocinemaitaliano.com") !== -1) {
      lnk = info.link
        .replace("http://festadocinemaitaliano.com", "")
        .replace("http://www.festadocinemaitaliano.com", "")
        .replace("https://festadocinemaitaliano.com", "")
        .replace("https://www.festadocinemaitaliano.com", "");
      if (lnk === "") {
        lnk = "/";
      }
      return (
        <Link to={lnk}>
          <div
            key={`k${i}`}
            className="carousel-img"
            style={this.drawBackgroundImage(info.img)}
          />
        </Link>
      );
    }

    return (
      <a href={info.link} target="_blank">
        <div
          key={`k${i}`}
          className="carousel-img"
          style={this.drawBackgroundImage(info.img)}
        />
      </a>
    );
  }

  renderBanner() {
    const { posters } = this.props;

    return posters["banner"].map((info, i) => {
      return (
        <CarouselItem key={i}>
          {this.renderBannerLink(i, info)}
          <div key={`z${i}`} className="carousel-caption">
            <p dangerouslySetInnerHTML={{ __html: info.description }} />
          </div>
        </CarouselItem>
      );
    });
  }

  renderBannerContainer() {
    const { posters } = this.props;

    if (
      typeof posters === "undefined" ||
      !posters.hasOwnProperty("banner") ||
      typeof posters["banner"] === "undefined" ||
      !posters["banner"].length
    ) {
      return null;
    }

    return (
      <div className="banner-wrapper no-top-border row">
        <div className="col-lg-12">
          <Carousel interval={5000}>{this.renderBanner()}</Carousel>
        </div>
      </div>
    );
  }

  handleResize(e) {
    this.ww = window.innerWidth;
    this.wh = window.innerHeight;
    const h = this.wh - document.getElementById("main-hdr").clientHeight - 26;
    let carousel = document.querySelectorAll(".carousel");
    if (typeof carousel !== "undefined" && carousel.length) {
      carousel[0].style.height = h + "px";
    }
  }

  getALLmovies(movies, movieIds) {
    /*
    const movieIds = Object.keys(movies)

    return movieIds.map((id) => {
      return movies[id]
    })
    */

    if (!movieIds) {
      return [];
    }

    return movieIds.map(id => {
      return movies[id];
    });
  }

  onSearchChange(e) {
    // console.log('onSearchChange', e)
  }

  gotoPage(page) {
    this.props.history.push("/pesquisa");
  }

  onClickTagLabel(tagname) {
    console.log("onClickTagLabel", tagname);
    this.props.dispatch(selectSection(tagname));
    this.props.history.push(`/filmes/${tagname}`);
  }

  render() {
    const {
      movies,
      isFetching,
      news,
      isFetchingNews,
      sections,
      sponsors,
      selectedMov2Filter,
      movieIds,
      sponsorIds
    } = this.props;

    const movies_2016 = this.getALLmovies(movies, movieIds);
    const { menus, dispatch, selectedSection, selectedAZ } = this.props;
    const top_menus = menus.top || [];
    const bottom_menus = menus.bottom || [];
    /*
    <Carousel>
      {this.renderCarrousel()}
    </Carousel>
    */
    return (
      <div>
        <HeaderView top_menus={top_menus} dispatch={dispatch} />
        <div className="row">
          <div className="col-lg-12 no-pad carousel-wrapper">
            <Carousel interval={3000}>{this.renderCarrousel()}</Carousel>
            <FooterLinks bottom_menus={bottom_menus} />
          </div>
          <SocialView
            customclass=""
            gotoPage={this.gotoPage}
            onChange={this.onSearchChange}
            dispatch={dispatch}
          >
            <SearchView
              gotoPage={this.gotoPage}
              onChange={this.onSearchChange}
              dispatch={dispatch}
            />
          </SocialView>
          <MoviesView
            className="top-red-border"
            movies_2016={movies_2016}
            isFetching={isFetching}
            dispatch={dispatch}
            scope="distrib"
            onClickTagLabel={this.onClickTagLabel}
            selectedMov2Filter={selectedMov2Filter}
            sections={sections}
            selectedSection={selectedSection}
            selectedAZ={selectedAZ}
          />
          {Object.keys(news).length ? (
            <NewsView news={news} isFetchingNews={isFetchingNews} />
          ) : null}
          {this.renderBannerContainer()}
          <SponsorView sponsors={sponsors} sponsorIds={sponsorIds} />
        </div>
      </div>
    );
  }
}

MovieMakerView.propTypes = {
  selectedCategory: PropTypes.string.isRequired,
  dispatch: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  movies: PropTypes.object.isRequired,
  movieIds: PropTypes.array.isRequired,
  isFetching: PropTypes.bool.isRequired,
  ids_by_year: PropTypes.array.isRequired,
  news: PropTypes.array.isRequired,
  isFetchingNews: PropTypes.bool.isRequired,
  selectedCity: PropTypes.string.isRequired,
  city_movies: PropTypes.object.isRequired,
  isFetchingMovieCity: PropTypes.bool.isRequired,
  cities: PropTypes.array.isRequired,
  isFetchingCities: PropTypes.bool.isRequired,
  selectedDay: PropTypes.string.isRequired,
  menus: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  selectedSection: PropTypes.string.isRequired,
  sections: PropTypes.array.isRequired,
  selectedAZ: PropTypes.number.isRequired,
  isFetchingPosters: PropTypes.bool.isRequired,
  posters: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  sponsors: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  sponsorIds: PropTypes.array.isRequired,
  isFetchingSpHome: PropTypes.bool.isRequired,
  selectedScope: PropTypes.string.isRequired,
  selectedMov2Filter: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  const {
    selectedMov2Filter,
    selectedScope,
    selectedCategory,
    moviesByCategory,
    byYear,
    selectedYear,
    getAllnews,
    selectedCity,
    getMoviesFromFestival,
    getAllCities,
    selectedDay,
    getMenus,
    getSections,
    selectedSection,
    selectedAZ,
    getPosters,
    getSponsorHome,
    router,
    movieIds
  } = state;
  const { isFetching, lastUpdated, items: movies } = moviesByCategory[
    selectedCategory
  ] || {
    isFetching: true,
    items: {}
  };
  const { ids: ids_by_year } = byYear[selectedYear] || {
    ids: []
  };

  const { isFetchingMenus, lastUpdatedMenus, items: menus } = getMenus[
    "distrib"
  ] || {
    isFetchingMenus: true,
    items: {}
  };

  const { isFetchingNews, lastUpdatedNews, items: news } = getAllnews[
    "all"
  ] || {
    isFetchingNews: true,
    items: []
  };

  const {
    isFetchingMovieCity,
    lastUpdatedCity,
    events: city_movies,
    numPastEvents
  } = getMoviesFromFestival[selectedCity] || {
    isFetchingMovieCity: true,
    items: {}
  };

  const { isFetchingCities, items: cities } = getAllCities["all"] || {
    isFetchingCities: true,
    items: []
  };

  const { isFetchingSections, items: sections } = getSections[
    `movies_${"distrib"}`
  ] || {
    isFetchingSections: true,
    items: []
  };

  const { isFetchingPosters, items: posters } = getPosters["distrib"] || {
    isFetchingPosters: true,
    items: {}
  };

  const { isFetchingSpHome, items: sponsors, ids: sponsorIds } = getSponsorHome[
    "all"
  ] || {
    isFetchingSpHome: true,
    items: {},
    ids: []
  };

  return {
    selectedMov2Filter,
    selectedScope,
    selectedCategory,
    selectedDay,
    movies,
    movieIds,
    isFetching,
    lastUpdated,
    ids_by_year,
    isFetchingNews,
    lastUpdatedNews,
    news,
    selectedCity,
    city_movies,
    isFetchingMovieCity,
    lastUpdatedCity,
    isFetchingCities,
    cities,
    isFetchingMenus,
    menus,
    lastUpdatedMenus,
    selectedSection,
    sections,
    isFetchingSections,
    selectedAZ,
    isFetchingPosters,
    posters,
    isFetchingSpHome,
    sponsors,
    sponsorIds,
    router,
    numPastEvents
  };
}

export default connect(mapStateToProps)(MovieMakerView);



// WEBPACK FOOTER //
// ./src/views/HomeView/MovieMakerView.js